// The legacy live site serves the Blood Sugar Control copy on this URL — hero,
// intro and "What should I eat?" all say blood sugar, on a page titled
// Hypothyroidism. That bug was ported here verbatim and is now fixed. There is
// no correct copy on the legacy site to port, so the thyroid text below is taken
// from the Hypothyroidism entry on the legacy /health-conditions page.
import DELIVERY from '../fragments/delivery';

const IMG = '/images/health';

const page = {
  slug: 'hypothyroidism-meal-prep',
  title: 'Hypothyroidism Meal Prep',
  hero: {
    title: 'Hypothyroidism',
    subtitle: 'Freshly cooked meals to support',
    image: `${IMG}/condition-hero.webp`,
  },
  blocks: [
    {
      type: 'imageText',
      paragraphs: [
        'Hypothyroidism is a condition in which the thyroid gland does not produce enough thyroid hormones, causing fatigue, in some cases weight gain, and a variety of other symptoms. Medical treatment is necessary, and the right nutrition can also assist with thyroid health.',
        "Our chefs make meals individually tailored to your specific needs for the price of takeout. Meals get delivered to your home. Pop them in the microwave for 2 mins and throw out the containers in the compost bin when you're done.",
        'No planning, no prep, no cooking, no clean up.',
        "To get started, take our quiz to build your nutritional profile. We'd be happy to connect with your doctor or registered dietitian as needed.",
      ],
      image: `${IMG}/condition-testimonial.webp`,
      imageSide: 'right',
    },
    { type: 'heading', text: 'Get support for thyroid health' },
    { type: 'cta', label: 'Get Started', to: '/quiz' },
    {
      type: 'text',
      heading: 'What should I eat?',
      paragraphs: [
        'Consume foods with vitamins B, selenium, zinc, vitamin D and iodine — brazil nuts, eggs, fish and shellfish, legumes, seeds and leafy greens are all good sources. Pay attention to ingredients like cruciferous vegetables, soy, cassava, turnips and millet, as they may affect your iodine levels; make sure you eat them cooked. Eat regularly rather than skipping meals, keep meals balanced across whole grains, lean protein and healthy fats, and stay hydrated.',
      ],
    },
    {
      type: 'form',
      formType: 'general',
      heading: 'Get in touch.',
      intro: "Have questions? Let's connect! Simply email Claire at claire@getsquarefare.com or send us a message via the form below.",
    },
    {
      type: 'quote',
      text: "As a nutritionist, it can be difficult if not seemingly impossible to find meal options for my clients that are convenient, flavorful, diverse, affordable AND that meet the client's nutritional needs. Square Fare checks all the boxes and more, and Claire makes the process of improving health and dietary habits a seamless process for both the client and the practitioner! Recommending Square Fare to health-conscious individuals, athletes, busy working professionals and anyone with a passion for good food is a total no-brainer. Thank you, Claire!",
      name: 'Emma Harvie, Functional Nutritionist at Athleats Nutrition',
    },
    { type: 'heading', text: 'FAQs' },
    {
      type: 'faq',
      items: [
        {
          q: 'Can I speak with a Square Fare registered dietitian partner?',
          a: ['Absolutely! Email Claire with your request: claire@getsquarefare.com.'],
        },
        {
          q: 'Can you accommodate allergies?',
          a: ['Yes, we do this all the time. Just let us know what your dietary constraints are when you take the quiz.'],
        },
        {
          q: 'What meals do you make?',
          a: ['Our meals change weekly, our weekly menu can be accessed here.'],
        },
        {
          q: 'When do you deliver?',
          a: [DELIVERY.line],
        },
        {
          q: 'What are your delivery zones?',
          a: [`We serve ${DELIVERY.zones}.`],
        },
        {
          q: 'How far in advance do I need to place the order?',
          a: [DELIVERY.cutoffLine],
        },
      ],
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
